export default function ({ store, redirect, params }) {
  // Se o usuário não está autenticado,
  // envia-o para a tela de login
  if (!store.state.app.auth.check) {
    return redirect({name: 'matricula-courseId', params: {courseId: params.courseId}})
  }
}
